import { useEffect, useState } from 'react'
import { getReportDropDepartmentsAPI } from '../../services/dropdown'

function UseReportDropDepartments(orgId, groupId, dsId) {
  const [options, setOptions] = useState([])
  const [rawData, setRawData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      try {
        const params = { orgId }
        if (groupId) params.groupId = groupId
        if (dsId) params.dsId = dsId
        const resp = await getReportDropDepartmentsAPI(params)
        if (!resp) return
        if (resp.status) {
          setRawData(resp.result)
          const newData = resp.result.map((d) => ({
            value: d?.dmId,
            label: `${d?.departmentName} (${d?.department})`
          }))
          setOptions(newData)
        } else {
          setOptions([])
          setRawData([])
        }
      } finally {
        setLoading(false)
      }
    }

    if (orgId) {
      getData()
    }
  }, [orgId, groupId, dsId])

  return { options, rawData, loading }
}

export default UseReportDropDepartments
